import React, { useState } from 'react';
import { Alert, Button, Card, Form } from 'react-bootstrap';
import { formatarValor, formatarValorAPI, formatarValorLocal } from '../../common/utils';

// Converte o valor formatado (ex.: "1.234,56") pra número, tratando vazio/zero como
// "sem valor informado" — evita mostrar "R$ 0,00" de forma inconsistente.
const paraNumero = (valor) => {
    const numero = parseFloat(formatarValorAPI(valor));
    return isNaN(numero) ? 0 : numero;
};

function GrupoFaturamentoAvulso({ laboratorioId, laboratorioNome, exames, selecionados, onToggleItem, onToggleTodos, onGerarFaturamento }) {
    const [usarValorManual, setUsarValorManual] = useState(false);
    const [valorManual, setValorManual] = useState('');

    const idsGrupo = exames.map(exame => String(exame.atendimento_servico_id));
    const selecionadosNoGrupo = idsGrupo.filter(id => selecionados.includes(id));
    const todosSelecionados = idsGrupo.length > 0 && selecionadosNoGrupo.length === idsGrupo.length;

    const valorSomadoSelecionados = exames
        .filter(exame => selecionadosNoGrupo.includes(String(exame.atendimento_servico_id)))
        .reduce((total, exame) => total + paraNumero(exame.orcamento), 0);

    return (
        <Card className="mb-3 border">
            <Card.Header className="d-flex align-items-center justify-content-between flex-wrap gap-2 bg-light">
                <div className="d-flex align-items-center gap-2">
                    <Form.Check
                        type="checkbox"
                        checked={todosSelecionados}
                        onChange={event => onToggleTodos(idsGrupo, event.target.checked)}
                        title="Selecionar todos deste laboratório"
                    />
                    <strong>{laboratorioNome}</strong>
                    <span className="badge bg-secondary">{exames.length} exame(s) pendente(s) de faturamento</span>
                </div>
            </Card.Header>
            <Card.Body>
                <ul className="list-unstyled mb-3">
                    {exames.map(exame => (
                        <li key={exame.id} className="d-flex align-items-center gap-2 mb-1">
                            <Form.Check
                                type="checkbox"
                                checked={selecionados.includes(String(exame.atendimento_servico_id))}
                                onChange={event => onToggleItem(exame.atendimento_servico_id, event.target.checked)}
                            />
                            <span>{exame.servico_procedimento_nome}</span>
                            <span className="text-muted small">
                                — {paraNumero(exame.orcamento) > 0 ? formatarValorLocal(paraNumero(exame.orcamento)) : 'sem valor unitário informado'}
                            </span>
                        </li>
                    ))}
                </ul>

                {selecionadosNoGrupo.length > 0 && (
                    <>
                        <p className="small text-muted mb-2">
                            Soma dos valores unitários dos exames selecionados: <strong>{formatarValorLocal(valorSomadoSelecionados)}</strong>
                            {valorSomadoSelecionados === 0 && ' — nenhum exame selecionado tem valor unitário informado.'}
                        </p>
                        <Form.Check
                            type="checkbox"
                            label="Informar valor total manualmente (para laboratórios que não passam valor por exame)"
                            className="mb-2"
                            checked={usarValorManual}
                            onChange={event => setUsarValorManual(event.target.checked)}
                        />
                        {usarValorManual && (
                            <>
                                <Alert variant="warning" className="py-2 small mb-2">
                                    Esse valor vai virar o total da Ordem de Serviço exatamente como digitado.
                                    Os valores unitários listados acima <strong>não são somados nem alterados</strong> —
                                    ficam só como referência.
                                </Alert>
                                <Form.Group className="mb-3" style={{ maxWidth: 220 }}>
                                    <Form.Label>Valor Total da Ordem de Serviço</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={valorManual}
                                        onChange={event => setValorManual(formatarValor(event.target.value))}
                                        placeholder="0,00"
                                    />
                                </Form.Group>
                            </>
                        )}

                        <Button
                            variant="primary"
                            size="sm"
                            onClick={() => onGerarFaturamento(idsGrupo, laboratorioId, usarValorManual ? valorManual : null)}
                        >
                            Gerar Faturamento ({selecionadosNoGrupo.length})
                        </Button>
                    </>
                )}
            </Card.Body>
        </Card>
    );
}

export default GrupoFaturamentoAvulso;
